const taskFailureReadPrefix = "xmirror.admin.tasks.failed.read";

export function taskFailureReadStorageKey(
  tenantGuid?: string,
  accountId?: string,
) {
  if (!tenantGuid || !accountId) return null;
  return `${taskFailureReadPrefix}.${tenantGuid}.${accountId}`;
}

export function acknowledgedTaskFailures(storageKey: string | null) {
  if (!storageKey) return 0;
  const stored = Number(window.localStorage.getItem(storageKey));
  return Number.isSafeInteger(stored) && stored > 0 ? stored : 0;
}

export function unreadTaskFailures(
  failedTaskCount: number,
  acknowledgedFailureCount: number,
) {
  return Math.max(0, failedTaskCount - acknowledgedFailureCount);
}

export function nextAcknowledgedTaskFailures(
  failedTaskCount: number,
  acknowledgedFailureCount: number,
  isViewingTasks: boolean,
) {
  return isViewingTasks
    ? failedTaskCount
    : Math.min(acknowledgedFailureCount, failedTaskCount);
}
